/**
 * Canonical list of element types supported by both the Flashcard runtime and the editor.
 */
export const ELEMENT_TYPES = ['text', 'image', 'checkbox-group', 'audio', 'video', 'shape'] as const

export type ElementType = (typeof ELEMENT_TYPES)[number]

export function isElementType(value: string): value is ElementType {
  return (ELEMENT_TYPES as readonly string[]).includes(value)
}
